import Donut from "./Donut";
import Line from "./Line";

const chartComponents = {
  Donut,
  Line,
}

export default chartComponents